module.exports = InternalShared('InternalShared/Dialog/LicenseIsRequired');